import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Custom `tailwind-merge` instance extended with Primer's non-numeric spacing tokens.
 *
 * `tailwind-merge` uses static string matching and only recognizes standard numeric
 * scales by default. Custom tokens like `--spacing-icon-*` must be registered here so
 * utilities like `size-icon-*` correctly deduplicate when overridden via `className`
 * (e.g. `<Icon className="size-6" />` cleanly replacing the default `size-icon-medium`).
 *
 * When adding new non-numeric spacing tokens in Supernova, register their suffixes here.
 * @see docs/styling.md#non-numeric-spacing-tokens-and-cn--tailwind-merge
 */
const customTwMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: ['icon-small', 'icon-medium', 'icon-large', 'icon-xl'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
